import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert } from "react-bootstrap";
import { FaPlus, FaEdit, FaTrash, FaCheck, FaEye } from "react-icons/fa";
import { IMaskInput } from "react-imask";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { formataDataExibicao, kitsStatus } from '../../common/utils';
import Paginacao from '../../common/pagination';

class PrestadorKits extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);

        this.ufOptions = {
            "AC": "Acre", "AL": "Alagoas", "AP": "Amapá", "AM": "Amazonas",
            "BA": "Bahia", "CE": "Ceará", "DF": "Distrito Federal", "ES": "Espírito Santo",
            "GO": "Goiás", "MA": "Maranhão", "MT": "Mato Grosso", "MS": "Mato Grosso do Sul",
            "MG": "Minas Gerais", "PA": "Pará", "PB": "Paraíba", "PR": "Paraná",
            "PE": "Pernambuco", "PI": "Piauí", "RJ": "Rio de Janeiro", "RN": "Rio Grande do Norte",
            "RS": "Rio Grande do Sul", "RO": "Rondônia", "RR": "Roraima", "SC": "Santa Catarina",
            "SP": "São Paulo", "SE": "Sergipe", "TO": "Tocantins"
        };

        this.state = {
            kitsEnviados: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,

            // Modal Adicionar Kit
            showModalKit: false,
            kitsProgramaLoading: false,
            kitsProgramaOptions: [],
            kitSelecionadoId: '',
            quantidade: 1,
            descricao: '',
            data_envio: '',
            responsavel_recebimento: '', // Novo campo

            // Endereços
            enderecos: [],
            enderecoSelecionado: '',
            showModalNovoEndereco: false,
            novoEndereco: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
                codigo: '', // Para armazenar ID do centro de referência
            },

            // Centros de referência do prestador
            centrosReferencia: [],
            centroSelecionadoParaEndereco: '', // ID do centro selecionado para usar endereço
            responsaveisCentroSelecionado: [], // Responsáveis do centro selecionado

            // Modal Editar Kit
            showModalEditKit: false,
            editKitLoading: false,
            editKit: {
                id: null,
                descricao: '',
                quantidade: 1,
                data_envio: '',
                status: '',
                data_envio_realizado: '',
                endereco_id: null,
                endereco_nome: '',
                endereco_compacto: '',
                dados_kit: {},
                responsavel_recebimento: '',
            },

            // Modal Visualizar Endereço
            showModalEndereco: false,
            enderecoVisualizado: null,
        };
    }

    componentDidMount() {
        this.carregarKits(this.state.page_numb);
        this.buscarEnderecos();
        this.buscarCentrosReferencia(); // Novo
    }
    
    buscarCentrosReferencia = () => {
        const { prestadorId } = this.props;

        api.get(`/centros_referencia/prestadores/`, { params: { prestador_id: prestadorId } })
            .then(response => {
                this.setState({ centrosReferencia: response.data.results || [] });
            })
            .catch(error => {
                console.error('Erro ao buscar centros de referência:', error);
                this.setState({ centrosReferencia: [] });
            });
    };

    carregarKits = (page_numb = 1) => {
        const { prestadorId } = this.props;

        if (!prestadorId) {
            this.setState({ loading: false, error: 'ID do prestador não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/pessoas/prestadores/kits/`, { params: { prestador_id: prestadorId, page: page_numb } })
            .then(response => {
                this.setState({
                    kitsEnviados: response.data.results || [],
                    kitsEnviadosData: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar kits do prestador';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.carregarKits(num_page);
    }

    buscarEnderecos = () => {
        const { prestadorId } = this.props;

        api.get(`/enderecos/`, { params: { prestador_id: prestadorId } })
            .then(response => {
                const enderecos = response.data.results || [];
                this.setState({ enderecos });
            })
            .catch(error => {
                console.error('Erro ao buscar endereços:', error);
                this.setState({ enderecos: [] });
            });
    };

    // === MODAL ADICIONAR KIT ===
    handleShowModalKit = async () => {
        const { programaId } = this.props;

        this.setState({
            showModalKit: true,
            kitsProgramaLoading: true,
            kitsProgramaOptions: [],
            kitSelecionadoId: '',
            quantidade: 1,
            descricao: '',
            data_envio: '',
            enderecoSelecionado: '',
            responsavel_recebimento: '',
            centroSelecionadoParaEndereco: '',
            responsaveisCentroSelecionado: [],
        });

        // Atualiza centros de referência e endereços sempre que abrir o modal
        this.buscarCentrosReferencia();
        this.buscarEnderecos();

        try {
            const resp = await api.get('/programas/kits/', { params: { programa_id: programaId } });
            const options = Array.isArray(resp.data?.results) ? resp.data.results : [];

            this.setState({
                kitsProgramaOptions: options,
                kitsProgramaLoading: false,
                kitSelecionadoId: options.length === 1 ? String(options[0].id) : '',
            });
        } catch (err) {
            console.error('Erro ao buscar kits do programa:', err);
            this.setState({ kitsProgramaLoading: false });
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: <p>Não foi possível carregar os kits do programa.</p>,
                showCloseButton: true,
            });
        }
    };

    handleCloseModalKit = () => {
        this.setState({ showModalKit: false });
    };

    handleChangeKitSelecionado = (e) => {
        this.setState({ kitSelecionadoId: e.target.value });
    };

    handleChangeQuantidade = (e) => {
        this.setState({ quantidade: e.target.value });
    };

    handleChangeDescricao = (e) => {
        this.setState({ descricao: e.target.value });
    };

    handleChangeDataEnvio = (e) => {
        this.setState({ data_envio: e.target.value });
    };

    handleChangeResponsavelEntrega = (e) => {
        this.setState({ responsavel_recebimento: e.target.value });
    };

    handleSelectEndereco = (endereco_id) => {
        // Verifica se é um endereço de centro de referência
        const endereco = this.state.enderecos.find(e => e.id === endereco_id);
        let responsaveisCentro = [];
        
        if (endereco && endereco.codigo) {
            // Busca responsáveis do centro de referência
            const centro = this.state.centrosReferencia.find(
                c => String(c.centro_referencia_id) === String(endereco.codigo)
            );
            if (centro && centro.dados_centro && centro.dados_centro.responsavel_recebimento) {
                let responsaveis = centro.dados_centro.responsavel_recebimento;
                if (typeof responsaveis === 'string') {
                    try {
                        responsaveis = JSON.parse(responsaveis);
                    } catch (e) {
                        responsaveis = [{ nome: responsaveis }];
                    }
                }
                if (Array.isArray(responsaveis)) {
                    responsaveisCentro = responsaveis;
                }
            }
        }
        
        this.setState({ 
            enderecoSelecionado: endereco_id,
            responsaveisCentroSelecionado: responsaveisCentro,
            responsavel_recebimento: '' // Limpa seleção anterior
        });
    };

    handleSelectCentroParaEndereco = async (centroId) => {
        if (!centroId) {
            this.setState({ 
                centroSelecionadoParaEndereco: '',
                responsaveisCentroSelecionado: []
            });
            return;
        }

        const centro = this.state.centrosReferencia.find(
            c => String(c.centro_referencia_id) === String(centroId)
        );

        if (!centro) return;

        // Busca dados completos do centro se necessário
        let dadosCentro = centro.dados_centro;
        if (!dadosCentro) {
            try {
                const response = await api.get(`/centros_referencia/${centroId}/`);
                dadosCentro = response.data;
            } catch (error) {
                console.error('Erro ao buscar dados do centro:', error);
                return;
            }
        }

        // Extrai responsáveis
        let responsaveis = [];
        if (dadosCentro.responsavel_recebimento) {
            if (typeof dadosCentro.responsavel_recebimento === 'string') {
                try {
                    responsaveis = JSON.parse(dadosCentro.responsavel_recebimento);
                } catch (e) {
                    responsaveis = [{ nome: dadosCentro.responsavel_recebimento }];
                }
            } else if (Array.isArray(dadosCentro.responsavel_recebimento)) {
                responsaveis = dadosCentro.responsavel_recebimento;
            }
        }

        this.setState({
            centroSelecionadoParaEndereco: centroId,
            responsaveisCentroSelecionado: responsaveis,
            novoEndereco: {
                nome: `Centro: ${dadosCentro.nome}`,
                cep: dadosCentro.cep || '',
                endereco: dadosCentro.endereco || '',
                numero: dadosCentro.numero || '',
                complemento: dadosCentro.complemento || '',
                bairro: dadosCentro.bairro || '',
                cidade: dadosCentro.cidade || '',
                uf: dadosCentro.uf || '',
                codigo: String(centroId), // Armazena ID do centro no código
            }
        });
    };

    handleSubmitKit = async (e) => {
        e.preventDefault();
        this.setState({ loadingModal: true });

        const { prestadorId, programaId } = this.props;
        const { kitSelecionadoId, quantidade, descricao, data_envio, enderecoSelecionado, responsavel_recebimento } = this.state;

        if (!kitSelecionadoId) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: <p>Por favor, selecione um kit.</p>,
                showCloseButton: true,
            });
            this.setState({ loadingModal: false });
            return;
        }

        if (!enderecoSelecionado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Atenção!',
                html: <p>Por favor, selecione um endereço de entrega.</p>,
                showCloseButton: true,
            });
            this.setState({ loadingModal: false });
            return;
        }

        try {
            const dadosKit = {
                prestador_id: prestadorId,
                programa_kit_id: kitSelecionadoId,
                quantidade: parseInt(quantidade) || 1,
                descricao,
                data_envio: data_envio || null,
                endereco_id: enderecoSelecionado,
                responsavel_recebimento: responsavel_recebimento || null,
            };

            await api.post('/pessoas/prestadores/kits/', dadosKit);

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Kit cadastrado com sucesso!</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false, showModalKit: false });
            this.carregarKits(this.state.page_numb);

        } catch (error) {
            let erro_msg = "Houve um erro ao cadastrar o kit";

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                erro_msg = campos.detail ? campos.detail : JSON.stringify(campos, null, 2);
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: <p>{erro_msg}</p>,
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
        }
    };

    // === MODAL NOVO ENDEREÇO ===
    handleShowModalNovoEndereco = async () => {
        this.setState({
            showModalNovoEndereco: true,
            novoEndereco: {
                nome: '',
                cep: '',
                endereco: '',
                numero: '',
                complemento: '',
                bairro: '',
                cidade: '',
                uf: '',
                codigo: '',
            },
            centroSelecionadoParaEndereco: '',
        });
        
        // Garante que os centros de referência estejam atualizados
        await this.buscarCentrosReferencia();
    };

    handleCloseModalNovoEndereco = () => {
        this.setState({ 
            showModalNovoEndereco: false,
            centroSelecionadoParaEndereco: '',
        });
    };

    handleChangeNovoEndereco = (event) => {
        const { name, value } = event.target;
        this.setState((prevState) => ({
            novoEndereco: {
                ...prevState.novoEndereco,
                [name]: value,
            },
        }));
    };

    onChangeCepNovoEndereco = (e) => {
        const rawValue = e.target.value;
        const cep = rawValue.replace(/\D/g, '');

        this.setState(prevState => ({
            novoEndereco: {
                ...prevState.novoEndereco,
                cep: cep
            }
        }));

        if (cep.length === 8) {
            fetch(`https://viacep.com.br/ws/${cep}/json/`)
                .then(response => response.json())
                .then(data => {
                    if (!data.erro) {
                        this.setState(prevState => ({
                            novoEndereco: {
                                ...prevState.novoEndereco,
                                endereco: data.logradouro,
                                bairro: data.bairro,
                                cidade: data.localidade,
                                uf: data.uf
                            }
                        }));
                    }
                });
        }
    };

    handleSubmitNovoEndereco = (e) => {
        e.preventDefault();
        this.setState({ loadingModal: true });

        const { novoEndereco, centroSelecionadoParaEndereco, responsaveisCentroSelecionado } = this.state;
        const { prestadorId } = this.props;

        if (!novoEndereco.nome || !novoEndereco.cep || !novoEndereco.endereco || 
            !novoEndereco.numero || !novoEndereco.bairro || !novoEndereco.cidade || !novoEndereco.uf) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: '<p>Por favor, preencha todos os campos obrigatórios.</p>',
                showCloseButton: true,
            });
            this.setState({ loadingModal: false });
            return;
        }

        // Desestrutura excluindo 'codigo' do spread
        const { codigo, ...enderecoSemCodigo } = novoEndereco;

        const data = {
            ...enderecoSemCodigo,
            complemento: novoEndereco.complemento || "",
            prestador_id: prestadorId,
            // Só inclui 'codigo' se tiver valor
            ...(codigo ? { codigo } : {}),
        };

        api.post('/enderecos/', data)
            .then(response => {
                const enderecoCriado = response.data;
                this.setState((prevState) => ({
                    enderecos: [...prevState.enderecos, enderecoCriado],
                    showModalNovoEndereco: false,
                    enderecoSelecionado: enderecoCriado.id,
                    // Mantém os responsáveis se veio de um centro
                    responsaveisCentroSelecionado: centroSelecionadoParaEndereco ? responsaveisCentroSelecionado : [],
                    novoEndereco: {
                        nome: '',
                        cep: '',
                        endereco: '',
                        numero: '',
                        complemento: '',
                        bairro: '',
                        cidade: '',
                        uf: '',
                        codigo: '',
                    },
                    centroSelecionadoParaEndereco: '',
                    loadingModal: false,
                }));

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    title: 'Sucesso!',
                    html: '<p>Endereço adicionado com sucesso!</p>',
                    icon: 'success',
                    showCloseButton: true,
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao adicionar o novo endereço.';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento.';
                } else if (error.response && error.response.status === 400) {
                    const campos = error.response.data;
                    erro_msg = campos.detail || JSON.stringify(campos, null, 2);
                }

                const MySwal = withReactContent(Swal);
                MySwal.fire({
                    icon: 'error',
                    title: 'Atenção!',
                    html: `<p>${erro_msg}</p>`,
                    showCloseButton: true,
                });

                this.setState({ loadingModal: false });
            });
    };

    // === MODAL EDITAR KIT ===
    handleOpenEditKit = async (kit) => {
        try {
            this.setState({ editKitLoading: true });

            let endereco_compacto = '';
            let endereco_nome = '';
            if (kit.endereco_id) {
                try {
                    const resp = await api.get(`/enderecos/${kit.endereco_id}/`);
                    endereco_nome = resp.data.nome || '';
                    endereco_compacto = this.compactaEndereco(resp.data);
                } catch (e) {
                    console.error('Erro ao buscar endereço:', e);
                }
            }

            this.setState({
                showModalEditKit: true,
                editKitLoading: false,
                editKit: {
                    id: kit.id,
                    descricao: kit.descricao || kit.dados_kit?.titulo || '',
                    quantidade: kit.quantidade || 1,
                    data_envio: kit.data_envio && kit.data_envio !== '1900-01-01' ? kit.data_envio : '',
                    status: kit.status ?? '',
                    data_envio_realizado: kit.data_envio_realizado || '',
                    endereco_id: kit.endereco_id || null,
                    endereco_nome,
                    endereco_compacto,
                    dados_kit: kit.dados_kit,
                    responsavel_recebimento: kit.responsavel_recebimento || '',
                }
            });
        } catch (error) {
            console.error('Erro ao abrir editor de kit:', error);
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                showCloseButton: true,
                html: <p>Não foi possível carregar os dados do kit.</p>,
            });
            this.setState({ editKitLoading: false });
        }
    };

    handleCloseModalEditKit = () => {
        this.setState({ showModalEditKit: false });
    };

    handleEditKitChange = (e) => {
        const { name, value } = e.target;
        this.setState((prev) => ({
            editKit: { ...prev.editKit, [name]: value }
        }));
    };

    handleEditKitStatusChange = (e) => {
        const status = e.target.value;
        this.setState((prev) => {
            const statusEnviado = String(status).toLowerCase() === 'enviado';
            return {
                editKit: {
                    ...prev.editKit,
                    status,
                    data_envio_realizado: statusEnviado ? prev.editKit.data_envio_realizado : ''
                }
            };
        });
    };

    handleUpdateKit = async (e) => {
        e.preventDefault();

        const { editKit } = this.state;
        const { id, descricao, quantidade, data_envio, status, data_envio_realizado, responsavel_recebimento } = editKit;

        const statusEnviado = String(status).toLowerCase() === 'enviado';

        if (statusEnviado && !data_envio_realizado) {
            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'warning',
                title: 'Campo obrigatório',
                text: 'Informe a data do envio realizado.',
                showCloseButton: true,
            });
            return;
        }

        this.setState({ editKitLoading: true });

        try {
            const payload = {
                descricao,
                quantidade: parseInt(quantidade) || 1,
                data_envio: data_envio || null,
                status,
                responsavel_recebimento: responsavel_recebimento || null,
            };

            if (data_envio_realizado) {
                payload['data_envio_realizado'] = data_envio_realizado;
            }

            await api.put(`/pessoas/prestadores/kits/${id}/`, payload);

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                title: <p>Kit atualizado com sucesso!</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.carregarKits(this.state.page_numb);

            this.setState({
                showModalEditKit: false,
                editKitLoading: false,
            });

        } catch (error) {
            console.error('Erro ao atualizar kit:', error);

            let erro_msg = "Não foi possível atualizar o kit.";
            if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                erro_msg = campos.detail ? campos.detail : JSON.stringify(campos, null, 2);
            } else if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                title: 'Atenção!',
                html: <p>{erro_msg}</p>,
                showCloseButton: true,
            });

            this.setState({ editKitLoading: false });
        }
    };

    // === EXCLUIR KIT ===
    handleDeleteKit = (kitId) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Excluir kit?',
            text: "Tem certeza que deseja excluir este kit?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                this.setState({ loading: true });

                api.delete(`/pessoas/prestadores/kits/${kitId}/`)
                    .then(response => {
                        MySwal.fire(
                            'Excluído!',
                            'O kit foi excluído com sucesso.',
                            'success'
                        );

                        this.setState({ loading: false });
                        this.carregarKits(this.state.page_numb);
                    })
                    .catch(error => {
                        MySwal.fire(
                            'Erro!',
                            'Houve um erro ao tentar excluir o kit. Por favor, tente novamente.',
                            'error'
                        );
                        this.setState({ loading: false });
                    });
            }
        });
    };

    // === VISUALIZAR ENDEREÇO ===
    handleShowModalEndereco = async (endereco_id) => {
        try {
            const resp = await api.get(`/enderecos/${endereco_id}/`);
            this.setState({
                showModalEndereco: true,
                enderecoVisualizado: resp.data,
            });
        } catch (error) {
            console.error('Erro ao buscar endereço:', error);
        }
    };

    handleCloseModalEndereco = () => {
        this.setState({ showModalEndereco: false, enderecoVisualizado: null });
    };

    compactaEndereco = (endereco) => {
        if (!endereco) return '-';
        const partes = [
            endereco.endereco,
            endereco.numero,
            endereco.bairro,
            endereco.cidade,
            endereco.uf
        ].filter(Boolean);
        return partes.join(', ') || '-';
    };

    renderRows = () => {
        const { kitsEnviados } = this.state;

        if (kitsEnviados.length > 0) {
            return kitsEnviados.map((kit) => (
                <tr key={kit.id}>
                    <td className="bg-id">#{kit.id}</td>
                    <td>
                        <div className="td-border">
                            {kit.dados_kit?.titulo || '-'}
                        </div>
                    </td>
                    <td>
                        <div className="td-border">
                            {kit.descricao || '-'}
                        </div>
                    </td>
                    <td>
                        <div className="td-border">
                            {kit.quantidade || 1}
                        </div>
                    </td>
                    <td>
                        <div className="td-border">
                            {kit.data_envio === '1900-01-01'
                                ? '-'
                                : formataDataExibicao(kit.data_envio)
                            }
                        </div>
                    </td>
                    <td>
                        <div className="td-border">
                            {kit.data_envio_realizado
                                ? formataDataExibicao(kit.data_envio_realizado)
                                : '-'
                            }
                        </div>
                    </td>
                    <td>
                        <div className="td-border">
                            <span className={`badge-agendamento badge-status-${kit.status}`}>
                                {kitsStatus[kit.status] || kit.status}
                            </span>
                        </div>
                    </td>
                    <td>
                        <Button
                            variant="secondary"
                            size="sm"
                            className="me-2"
                            onClick={() => this.handleOpenEditKit(kit)}
                        >
                            <FaEye className="me-1" /> Visualizar
                        </Button>
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => this.handleDeleteKit(kit.id)}
                        >
                            <FaTrash className="me-1" /> Excluir
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={8}>Nenhum kit cadastrado para este prestador</td>
            </tr>
        );
    };

    render() {
        const {
            loading,
            loadingModal,
            error,
            showModalKit,
            showModalEditKit,
            showModalNovoEndereco,
            showModalEndereco,
            kitsProgramaLoading,
            kitsProgramaOptions,
            kitSelecionadoId,
            quantidade,
            descricao,
            data_envio,
            enderecos,
            enderecoSelecionado,
            novoEndereco,
            editKit,
            editKitLoading,
            enderecoVisualizado,
            kitsEnviadosData,
            page_numb,
            responsavel_recebimento,
            centrosReferencia,
            centroSelecionadoParaEndereco,
            responsaveisCentroSelecionado,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h6><strong>Kits do Prestador</strong></h6>
                            </Col>
                            <Col sm={6} xs={6} className="text-end">
                                <Button
                                    type="button"
                                    variant="success"
                                    className="btn-sm"
                                    disabled={loading}
                                    onClick={this.handleShowModalKit}
                                >
                                    <FaPlus className="me-1" /> Adicionar Kit
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Kit</th>
                                    <th>Descrição</th>
                                    <th>Quantidade</th>
                                    <th>Data Agendada</th>
                                    <th>Data Envio Realizado</th>
                                    <th>Status</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={8}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={8}>{error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>

                        {kitsEnviadosData && kitsEnviadosData.results && kitsEnviadosData.results.length > 0 &&
                            <Paginacao
                                dados={kitsEnviadosData}
                                loading={loading}
                                page_numb={page_numb}
                                _onClickPagina={this.onClickPagina}
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Adicionar Kit */}
                <Modal show={showModalKit} onHide={this.handleCloseModalKit} size="lg" backdrop="static">
                    <Form onSubmit={this.handleSubmitKit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Adicionar Kit</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col sm={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Kit <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={kitSelecionadoId}
                                            onChange={this.handleChangeKitSelecionado}
                                            disabled={kitsProgramaLoading}
                                        >
                                            <option value="">
                                                {kitsProgramaLoading ? 'Carregando kits...' : 'Selecione um kit'}
                                            </option>
                                            {kitsProgramaOptions.map(k => (
                                                <option key={k.id} value={k.id}>{k.titulo}</option>
                                            ))}
                                        </Form.Control>
                                        {(!kitsProgramaLoading && kitsProgramaOptions.length === 0) && (
                                            <Form.Text className="text-warning">
                                                Nenhum kit disponível para este programa.
                                            </Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Quantidade <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="number"
                                            min="1"
                                            value={quantidade}
                                            onChange={this.handleChangeQuantidade}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label>Descrição</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Descrição do envio"
                                    value={descricao}
                                    onChange={this.handleChangeDescricao}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Data Prevista de Envio</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={data_envio}
                                    onChange={this.handleChangeDataEnvio}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Endereço de Entrega <span className="text-danger">*</span></Form.Label>
                                {enderecos.length > 0 ? (
                                    <div className="mb-2">
                                        {enderecos.map((endereco) => (
                                            <Form.Check
                                                key={endereco.id}
                                                type="radio"
                                                id={`endereco-${endereco.id}`}
                                                name="enderecoSelecionado"
                                                label={
                                                    <>
                                                        {endereco.nome} - {this.compactaEndereco(endereco)}
                                                        {endereco.codigo && (
                                                            <span className="badge bg-info ms-2">Centro de Ref.</span>
                                                        )}
                                                    </>
                                                }
                                                checked={enderecoSelecionado === endereco.id}
                                                onChange={() => this.handleSelectEndereco(endereco.id)}
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <Alert variant="warning">
                                        Nenhum endereço cadastrado para este prestador.
                                    </Alert>
                                )}
                                <Button
                                    variant="outline-secondary"
                                    size="sm"
                                    onClick={this.handleShowModalNovoEndereco}
                                >
                                    <FaPlus className="me-1" /> Adicionar Novo Endereço
                                </Button>
                            </Form.Group>
                            
                            <Form.Group className="mb-3">
                                <Form.Label>Responsável Recebimento</Form.Label>
                                {responsaveisCentroSelecionado.length > 0 ? (
                                    <Form.Control
                                        as="select"
                                        value={responsavel_recebimento}
                                        onChange={this.handleChangeResponsavelEntrega}
                                    >
                                        <option value="">Selecione um responsável ou digite abaixo</option>
                                        {responsaveisCentroSelecionado.map((resp, idx) => (
                                            <option key={idx} value={resp.nome}>
                                                {resp.nome} {resp.telefone ? `(${resp.telefone})` : ''}
                                            </option>
                                        ))}
                                        <option value="__outro__">Outro (digitar)</option>
                                    </Form.Control>
                                ) : (
                                    <Form.Control
                                        type="text"
                                        placeholder="Nome do responsável recebimento"
                                        value={responsavel_recebimento}
                                        onChange={this.handleChangeResponsavelEntrega}
                                    />
                                )}
                                {responsavel_recebimento === '__outro__' && (
                                    <Form.Control
                                        type="text"
                                        className="mt-2"
                                        placeholder="Digite o nome do responsável"
                                        onChange={(e) => this.setState({ responsavel_recebimento: e.target.value })}
                                    />
                                )}
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={this.handleCloseModalKit}>
                                Cancelar
                            </Button>
                            <Button type="submit" variant="success" disabled={loadingModal}>
                                {loadingModal ? <span className="spinner-border spinner-border-sm" /> : (
                                    <><FaCheck className="me-1" /> Salvar</>
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Modal Novo Endereço */}
                <Modal show={showModalNovoEndereco} onHide={this.handleCloseModalNovoEndereco} size="lg" backdrop="static">
                    <Form onSubmit={this.handleSubmitNovoEndereco}>
                        <Modal.Header closeButton>
                            <Modal.Title>Adicionar Novo Endereço</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {/* Seleção de Centro de Referência */}
                            {centrosReferencia.length > 0 && (
                                <Alert variant="info" className="mb-3">
                                    <Form.Group>
                                        <Form.Label><strong>Usar endereço de um Centro de Referência?</strong></Form.Label>
                                        <Form.Control
                                            as="select"
                                            value={centroSelecionadoParaEndereco}
                                            onChange={(e) => this.handleSelectCentroParaEndereco(e.target.value)}
                                        >
                                            <option value="">Não, cadastrar novo endereço manualmente</option>
                                            {centrosReferencia.map((centro) => (
                                                <option key={centro.centro_referencia_id} value={centro.centro_referencia_id}>
                                                    {centro.dados_centro?.nome || `Centro #${centro.centro_referencia_id}`}
                                                </option>
                                            ))}
                                        </Form.Control>
                                        <Form.Text className="text-muted">
                                            Selecione um centro para preencher automaticamente o endereço.
                                        </Form.Text>
                                    </Form.Group>
                                </Alert>
                            )}

                            <Form.Group className="mb-3">
                                <Form.Label>Nome do Local <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ex: Consultório, Clínica, etc."
                                    name="nome"
                                    value={novoEndereco.nome}
                                    onChange={this.handleChangeNovoEndereco}
                                />
                            </Form.Group>

                            <Row>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CEP <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as={IMaskInput}
                                            mask="00000-000"
                                            name="cep"
                                            placeholder="CEP"
                                            value={novoEndereco.cep}
                                            onChange={this.onChangeCepNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Endereço <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Endereço"
                                            name="endereco"
                                            value={novoEndereco.endereco}
                                            onChange={this.handleChangeNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Número <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Nº"
                                            name="numero"
                                            value={novoEndereco.numero}
                                            onChange={this.handleChangeNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Complemento</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Complemento"
                                            name="complemento"
                                            value={novoEndereco.complemento}
                                            onChange={this.handleChangeNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Bairro <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Bairro"
                                            name="bairro"
                                            value={novoEndereco.bairro}
                                            onChange={this.handleChangeNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Cidade <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Cidade"
                                            name="cidade"
                                            value={novoEndereco.cidade}
                                            onChange={this.handleChangeNovoEndereco}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row>
                                <Col sm={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>UF <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            as="select"
                                            name="uf"
                                            value={novoEndereco.uf}
                                            onChange={this.handleChangeNovoEndereco}
                                        >
                                            <option value="">Selecione</option>
                                            {Object.keys(this.ufOptions).map((sigla) => (
                                                <option key={sigla} value={sigla}>{sigla}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={this.handleCloseModalNovoEndereco}>
                                Cancelar
                            </Button>
                            <Button type="submit" variant="success" disabled={loadingModal}>
                                {loadingModal ? <span className="spinner-border spinner-border-sm" /> : (
                                    <><FaCheck className="me-1" /> Salvar Endereço</>
                                )}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Modal Editar Kit */}
                <Modal show={showModalEditKit} onHide={this.handleCloseModalEditKit} size="lg" backdrop="static">
                    <Form onSubmit={this.handleUpdateKit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Editar {editKit?.dados_kit?.titulo} (#{editKit?.id})</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {editKitLoading ? (
                                <div className="text-center py-4">
                                    <span className="spinner-border spinner-border-sm" />
                                </div>
                            ) : (
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Descrição</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="descricao"
                                            value={editKit.descricao}
                                            onChange={this.handleEditKitChange}
                                        />
                                    </Form.Group>

                                    <Row>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Quantidade</Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    min="1"
                                                    name="quantidade"
                                                    value={editKit.quantidade}
                                                    onChange={this.handleEditKitChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Status</Form.Label>
                                                <Form.Control
                                                    as="select"
                                                    name="status"
                                                    value={editKit.status}
                                                    onChange={this.handleEditKitStatusChange}
                                                >
                                                    {Object.entries(kitsStatus).map(([key, label]) => (
                                                        <option key={key} value={key}>{label}</option>
                                                    ))}
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col sm={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Data Prevista de Envio</Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="data_envio"
                                                    value={editKit.data_envio || ''}
                                                    onChange={this.handleEditKitChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    {String(editKit.status).toLowerCase() === 'enviado' && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Data do Envio Realizado <span className="text-danger">*</span></Form.Label>
                                            <Form.Control
                                                type="date"
                                                name="data_envio_realizado"
                                                value={editKit.data_envio_realizado || ''}
                                                onChange={this.handleEditKitChange}
                                                required={String(editKit.status).toLowerCase() === 'enviado'}
                                            />
                                        </Form.Group>
                                    )}

                                    <Form.Group className="mb-3">
                                        <Form.Label>Endereço de Entrega</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={editKit.endereco_nome ? `${editKit.endereco_nome} - ${editKit.endereco_compacto}` : (editKit.endereco_compacto || '-')}
                                            disabled
                                        />
                                    </Form.Group>
                                    
                                    <Form.Group className="mb-3">
                                        <Form.Label>Responsável Recebimento</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="responsavel_recebimento"
                                            placeholder="Nome do responsável recebimento"
                                            value={editKit.responsavel_recebimento || ''}
                                            onChange={this.handleEditKitChange}
                                        />
                                    </Form.Group>
                                </>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="light" onClick={this.handleCloseModalEditKit}>
                                Cancelar
                            </Button>
                            <Button type="submit" variant="success" disabled={editKitLoading}>
                                {editKitLoading ? <span className="spinner-border spinner-border-sm" /> : 'Salvar Alterações'}
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Modal Visualizar Endereço */}
                <Modal show={showModalEndereco} onHide={this.handleCloseModalEndereco}>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalhes do Endereço</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {enderecoVisualizado ? (
                            <>
                                <p><strong>Nome:</strong> {enderecoVisualizado.nome}</p>
                                <p><strong>CEP:</strong> {enderecoVisualizado.cep}</p>
                                <p><strong>Endereço:</strong> {enderecoVisualizado.endereco}</p>
                                <p><strong>Número:</strong> {enderecoVisualizado.numero}</p>
                                <p><strong>Complemento:</strong> {enderecoVisualizado.complemento || '-'}</p>
                                <p><strong>Bairro:</strong> {enderecoVisualizado.bairro}</p>
                                <p><strong>Cidade:</strong> {enderecoVisualizado.cidade}</p>
                                <p><strong>UF:</strong> {enderecoVisualizado.uf}</p>
                            </>
                        ) : (
                            <p>Carregando...</p>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseModalEndereco}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default PrestadorKits;
